import CaseStudy, {
  CASE_STUDY_TYPES,
} from "../../../components/case-study/CaseStudy"
import Header from "../../../components/Header"
import Layout from "../../../components/Layout"
import ThumbnailImage from "../../../images/thumbnails/gitex_thumb_2025.png"

export function Index() {
  return (
    <Layout
      title="Attendee-led marketing that contributed to GITEX GLOBAL’s 200K+ attendance"
      description="32K+ activated attendees driving referrals, reach, and measurable ROI across the event lifecycle."
      metaImage={ThumbnailImage}
      keywords={[
        "GITEX Global case study, Dubai tech conference, world largest tech event, Middle East technology summit, Dubai innovation showcase, Gulf tech conference, Arab world tech events, GITEX Dubai photos, tech expo networking, international tech summit, UAE technology events, Dubai startup showcase, Middle East innovation hub, global tech gathering, Dubai tech ecosystem",
      ]}
      noIndex
    >
      <Header />
      <CaseStudy type={CASE_STUDY_TYPES.GITEX_GLOBAL_2025} />
    </Layout>
  )
}

export default Index
